import { render, staticRenderFns } from "./CondicaoEntrega.vue?vue&type=template&id=422baf93"
import script from "./CondicaoEntrega.vue?vue&type=script&lang=js"
export * from "./CondicaoEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports